/* eslint-disable no-underscore-dangle */

import ApiService from '../api/ApiService';

/**
 * CodeCompilerService
 */

let clearHandle;

export default {
    clearCheckStatusInterval() {
        clearInterval(clearHandle);
    },

    checkStatus(questionId, sourceCodeCompilationSubmissionId, checkAgainstEvaluationTestCases) {
        return new Promise((resolve, reject) => {
            clearHandle = setInterval(() => {
                ApiService.checkSourceCodeCompilation(questionId, sourceCodeCompilationSubmissionId, checkAgainstEvaluationTestCases)
                    .then((response) => {
                        const result = response.result;
                        if (result.status_code > 8) {
                            this.clearCheckStatusInterval();
                            resolve(result, checkAgainstEvaluationTestCases);
                        }
                    })
                    .catch((error) => {
                        this.clearCheckStatusInterval();
                        reject(error);
                    });
            }, 5000);
        });
    },

    submitCodeForCompilation(questionId, userData, checkAgainstEvaluationTestCases) {
        this.clearCheckStatusInterval();
        return ApiService.submitCodeForCompilation(questionId, userData, checkAgainstEvaluationTestCases)
            .then((response) => {
                return this.checkStatus(questionId, response.sourceCodeCompilationSubmissionId, checkAgainstEvaluationTestCases);
            });
    },
};
